<template>
<div>
  <div class="top">
    <el-row :span="24">
      <el-steps :active="idcardQrGenerateProcess" class="stepClass" align-center="true">
        <el-step><span slot="title" class="title"><i class="fa fa-edit fa-x"></i>编辑名片内容</span></el-step>
        <el-step><span slot="title" class="title"><i class="fa fa-upload fa-x"></i>上传图像</span></el-step>
        <el-step><span slot="title" class="title"><i class="fas fa-cut fa-x"></i>裁剪生成</span></el-step>
        <el-step><span slot="title" class="title"><i class="far fa-save fa-x"></i>保存图片</span></el-step>
      </el-steps>
    </el-row>
  </div>
  <!-- 第一个步骤：编辑名片内容 -->
  <div class="step1" v-if='idcardQrGenerateProcess==0'>
    <div class="main">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">

        <el-form-item label="姓名" class="item" placeholder="必填" prop="name">
          <el-input  v-model="ruleForm.name"></el-input>
        </el-form-item>

        <el-form-item label="手机" class="item" prop="phone">
          <el-input  v-model.number="ruleForm.phone"></el-input>
        </el-form-item>

        <el-form-item label="单位" class="item" prop="company">
          <el-input v-model="ruleForm.company"></el-input>
        </el-form-item>

        <el-form-item label="职位" class="item" prop="job">
          <el-input v-model="ruleForm.job"></el-input>
        </el-form-item>

        <el-form-item label="微信" class="item" prop="wechat">
          <el-input v-model="ruleForm.wechat"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" class="item" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item label="地址" class="item" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <!-- 新加项 -->
        <!-- <el-form-item  class="item label-input-item" v-for="(additems, index) in ruleForm.additems"
         :key="additems.key" :prop="'additems.' + index + '.value'">
          <div class="add_item">
            <el-input class="label-input1" placeholder="项目名" v-model="additems.labels"></el-input>
            <el-input class="label-input2" placeholder="内容" v-model="additems.value"></el-input>
            <i class="fa fa-minus" aria-hidden="true" @click.prevent="removeadds(additems)"></i>
          </div>
        </el-form-item> -->

        <!-- 按钮 -->
        <div class="button_box1" style="text-align:center;">
          <!-- <div class="buttonadd">
            <el-button type="danger" size="small" plain round class="btn1" @click="additem()">
              增加项目<i class="fa fa-plus"></i>
            </el-button>
          </div> -->
          <el-button type="danger" size="small" round class="btn2" @click="submitForm('ruleForm')">
            &nbsp;&nbsp;&nbsp;提交&nbsp;&nbsp;&nbsp;
          </el-button>
        </div>

      </el-form>
    </div>
  </div>

  <!-- 第二个步骤：上传头像 -->
  <div class="step2" v-if='idcardQrGenerateProcess==1'>
    <el-upload drag class="qr-src-uploader" action="" :on-change="onUploadChange" :multiple="false" :auto-upload="false">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <el-button @click="idcardQrGenerateProcess--" class="button1">上一步</el-button>
  </div>

  <!-- 第三个步骤  裁剪图像 -->
    <div class="step3" v-if="idcardQrGenerateProcess == 2" :span="24">
      <cropper :src="selectedPic.url" @api="getCropApi" class="cropper"></cropper>
      <div class="button_box3">
        <el-button @click="idcardQrGenerateProcess--" class="button3">上一步</el-button>
        <el-button @click="cropImage" class="button4">生成美钥码</el-button>
      </div>
    </div>

  <!-- 第四个步骤，预览生成的图片进行下一步操作 -->
    <div class="step4" v-if="idcardQrGenerateProcess == 3" :span="24">
      <div style="text-align:center;margin-top:20px;">
        <img :src="'/qrdata/temp/' + qr.qrfile" class="disqr" alt="美钥二维码">
      </div>
      <div class="button_box4">
        <el-button @click="idcardQrGenerateProcess--" class="button5">重新裁剪</el-button>
        <el-button @click="saveQr()" class="button6">保存图片</el-button>
      </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import cropper from './cropper.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    cropper
  },
  data () {
    // 手机号码验证
    let isvalidPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字'))
      } else {
        if (value.toString().length !== 8 && value.toString().length !== 11) {
          callback(new Error('手机号码必须为8或11位'))
        } else {
          callback()
        }
      }
    }
    return {
      idcardQrGenerateProcess: 0,
      selectedPic: '', // 上传的图像本地文件地址及名称，blob
      cropperApi: undefined,
      qr: undefined, // 生成的二维码
      ruleForm: {// 表单数据
        name: '',
        company: '',
        job: '',
        phone: '',
        email: '',
        address: '',
        wechat: '',
        imageUrl: '',
        additems: [{
          labels: '',
          value: ''
        }]
      },

      // 校验规则
      rules: {
        name: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
        ],
        company: [
          {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
        ],
        job: [
          {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: isvalidPhone, trigger: 'blur'}
        ],
        email: [
          {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change'}
        ],
        address: [
          {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
        ],
        wechat: [
          {min: 3, max: 30, message: '长度在3到30个字符', trigger: 'blur'}
        ],
        value: [
          {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['logined', 'username'])
  },
  mounted () {
    document.title = '美钥二维码 - 制作名片美钥码'
  },
  methods: {
    // 提交表单并进入第二步
    submitForm: function (formName) {
      const vm = this
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          vm.idcardQrGenerateProcess = 1
        } else {
          return false
        }
      })
    },
    onUploadChange (file) {
      const vm = this
      // 进入第3步
      vm.selectedPic = file
      vm.idcardQrGenerateProcess = vm.idcardQrGenerateProcess + 1
    },
    getCropApi (api) {
      this.cropperApi = api
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    cropImage () { // 裁剪图片
      const vm = this
      if (vm.cropperApi) {
        let canvas = vm.cropperApi.getCroppedCanvas({
          width: 512
        })
        let canvasDataURL = canvas.toDataURL('image/jpeg')
        let blob = vm.dataURLtoBlob(canvasDataURL)
        // 上传图像，并进行图像生成
        let formData = new FormData()
        formData.append('url', '')
        formData.append('srcImage', blob, 'cropImage.jpg')
        formData.append('resource', JSON.stringify(vm.ruleForm))
        formData.append('type', 'idcard')
        $.ajax({
          url: '/v1/generate/qr',
          type: 'POST',
          data: formData,
          async: false,
          enctype: 'multipart/form-data',
          processData: false,  // 告诉jQuery不要去处理发送的数据
          contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
          cache: false
        })
        .done(function (data) {
          // 接受生成的二维码信息数据
          vm.qr = data.data
          // 跳转到下个界面
          vm.idcardQrGenerateProcess ++
        })
        .fail(function () {
          vm.$message.error('请求错误，请稍后再试！')
        })
      }
    },
    // 保存生成的美钥码
    saveQr () {
      const vm = this
      vm.$http.put(`/v1/user/qrs/${vm.qr.qrid}/owner`)
      .then(response => {
        if (response.data.code === 200) {
          vm.$message.info('保存成功！')
          vm.$router.push('/labelManage/labelid/all/n/10/p/1')
        } else {
          vm.$message.error('保存失败，请稍后再试')
        }
      }).catch((error) => {
        console.log(error)
        if (error.response.status === 507) {
          // 空间资源不足
          if (error.response.data.code === 507001) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者清理部分空间后重试。')
          // 二维码空间不足
          } else if (error.response.data.code === 507002) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者删除部分二维码后重试。')
          }
        }
      })
    },
    // resetForm (formName) {
    //   this.$refs[formName].resetFields()
    // },
    removeadds (item) {
      // 删除添加项
      let index = this.ruleForm.additems.indexOf(item)
      if (index !== -1) {
        this.ruleForm.additems.splice(index, 1)
      }
    },
    additem () {
      this.ruleForm.additems.push({
        value: '',
        key: Date.now()
      })
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style scoped>
.main{
  margin:20px 20% 0 20%;
  padding:50px;
  background-color: #fff;
}
.item{
  margin-left: 15%;
  height: 40px;
}
.el-input{
  width: 70%;
  float: left;
}
/* .item[data-v-feeee856] {
    width: 80%;
} */
.fa-minus{
  margin-left: 10px;
  cursor:pointer;
}
.fa-plus{
  margin-left: 10px;
}
/* 第一页两按钮 */
.buttonadd{
  padding-top: 30px;
  width: 50%;
  float: left;
  text-align: left;
}
.btn1{
  margin-left:45%;
  width: 50%;
  height: 50px;
  font-size: 20px;
}
.btn2{
  margin-left: 5%;
  width: 200px;
  height: 50px;
  font-size: 20px;
}
/* 第二三四页按钮 */
.step2,.step3,.step4{
  text-align: center;
}
.button1,.button3,.button4,.button5,.button6{
  margin: 80px 0;
}
.button_box1,.button_box3,.button_box4{
  text-align: center;
  margin-bottom: 100px;
}
.button4,.button6{
  margin-left: 20px;
}
.cropper{
  margin-bottom: 0;
}
/* 新增项标签及内容 */
.label-input1{
  float: left;
  width: 80px;
  margin-left: 5%;
}
.label-input2{
  float: left;
  margin-left: 10px;
  width: 60%;
}
.label-input-item{
  margin: 0;
  height: 55px;
  width: 1;
}
.add_item{
  width: 1;
}
@media screen and (max-width: 1200px) {
  /* 1104 */
  .main{
    margin: 20px 15% 0 15%;
  }
  /* 新增项标签及内容 */
  .label-input1{
  width: 75px;
  }
  .label-input2{
    width: 55%;
  }
  /* 按钮 */
  .btn1{
    font-size: 17px;
    height: 45px;
  }
  .btn2{
    font-size: 17px;
    height: 45px;
  }
}
@media screen and (max-width: 992px) {
  /* 865 */
  .main{
    margin: 20px 12% 0 12%;
  }
  .item{
    margin-left: 12%;
    height: 35px;
  }
  .el-input{
    font-size: 12px;
    width: 80%;
  }
  /* 新增项标签及内容 */
  .label-input1{
  width: 75px;
  margin-left: -80px;
  }
  .label-input2{
    width: 75%;
  }
  /* 按钮 */
  .fa-plus{
    margin-left: 5px;
  }
  .btn1{
    font-size: 15px;
    height: 40px;
  }
  .btn2{
    font-size: 15px;
    height: 40px;
  }
}
@media screen and (max-width: 768px) {
  .title{
    font-size: 13px;
  }
  .item{
    margin-left: 0;
    height: 30px;
  }
  .el-input{
    width: 90%;
  }
  /* 新增项标签及内容 */
  .add_item{
    width: 110%;
  }
  .label-input1{
    width: 75px;
    margin-left: -80px;
  }
  .label-input2{
    margin-left: 10px;
    width: 80%;
  }
  /* 按钮 */
  .btn1{
    height: 35px;
    margin-left: 30%;
    width: 60%;
  }
  .btn2{
    height: 35px;
    margin-left: 5%;
    width: 60%;
  }
}
@media screen and (max-width: 540px) {
  .main{
    margin: 10px 5% 0 5%;
  }
  .item{
    margin-left: -5%;
  }
  .btn1{
    width: 65%;
    font-size: 13px
  }
  .btn2{
    width: 65%;
    font-size: 13px;
  }
}
@media screen and (max-width: 414px) {
  .item{
    margin-left: -15%;
    height: 27px;
  }
  .el-form{
    width: 110%;
  }
  .btn1{
    margin-left: 15%;
    width: 70%;
  }
  .btn2{
    margin-left: 0;
    width: 70%;
  }
}
@media screen and (max-width: 375px) {
  .title{
    font-size: 10px;
  }
  .item{
    /* height: 25px; */
    margin-left: -22%;
  }
  .el-form{
    width: 120%;
  }
  .el-form-item__content{
    line-height: 30px;
    font-size: 12px;
  }
  .btn1{
    margin-left: -5%;
    width: 90%;
  }
  .btn2{
    width: 90%;
  }
}
@media screen and (max-width: 320px) {
  .label-input1{
    margin-left: -8%;
    width: 60px;
  }
  .label-input2{
    margin-left: 2px;
  }
}
</style>
